import { ApiOrderItem, ApiProduct } from '../../../types';
import { EditOrderProductBox } from './ProductBox/EditOrderProductBox';
import './ProductListing.css';

type ProductListingProps = {
	products: ApiProduct[];
	highlightId?: number | null;
	className?: string;
	onChange: (item: ApiOrderItem) => void;
};

export const ProductListing = ({
	products,
	highlightId,
	className = '',
	onChange,
}: ProductListingProps): JSX.Element => {
	return (
		<div className={'product-listing ' + className}>
			{products.map((p) => (
				<EditOrderProductBox onChange={onChange} highlight={p.id === highlightId} product={p} key={p.id} />
			))}
		</div>
	);
};
